
import { EscortProfile } from '@/types';

/**
 * Generate a placeholder image URL for profiles without photos
 * @param profile Optional profile object for customized placeholders
 * @returns URL to a placeholder image
 */
export const getPlaceholderImage = (profile?: EscortProfile | null): string => {
  // Default color for placeholders
  const backgroundColor = 'e0e0e0';
  const textColor = '666666';
  
  // Get the first letter of the display name, or use a question mark if none is available
  const initial = profile?.displayName ? profile.displayName.charAt(0).toUpperCase() : '?';
  
  // Generate a placeholder based on profile attributes if available
  let genderIndicator = '';
  
  if (profile?.attributes?.gender) {
    // Add gender-specific emoji or symbol
    switch (profile.attributes.gender.toLowerCase()) {
      case 'female':
        genderIndicator = '♀️';
        break;
      case 'male':
        genderIndicator = '♂️';
        break;
      case 'non-binary':
        genderIndicator = '⚧️';
        break;
      case 'trans':
        genderIndicator = '⚧️';
        break;
      default:
        genderIndicator = '';
    }
  }
  
  // Use with SVG placeholder or external service like placehold.co
  // For example with placehold.co:
  return `https://placehold.co/400x600/${backgroundColor}/${textColor}?text=${initial}${genderIndicator}`;
};
